<template>
  <div class="fluid">
    <b-card no-body class="mb-1 mt-3">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-1 variant="danger"
          >Data Obat Masuk</b-button
        >
      </b-card-header>
      <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text
            >Pada bagian ini, Dinputkan data Masuk OBAT
            <a
              href="javascript:void(0)"
              v-b-modal.bv-modal-listobat
              class="float-right"
              >List Data Obat</a
            ></b-card-text
          >
          <!-- {{ listobat }} -->
          <div class="row mb-0" size="sm" v-show="false">
            <div class="col-md-8">
              Nama Siswa:
              <vue-bootstrap-typeahead
                ref="typeahead"
                class="mb-4"
                size="sm"
                v-model="query"
                :data="users"
                :serializer="(item) => item.nama"
                @hit="
                  selectedUser = $event;
                  noasrama = selectedUser.noasrama;
                  kelas = selectedUser.nokelas;
                "
                placeholder="pencarian nama"
              />
            </div>

            <div class="col-md mt-1"><br />NIS:{{ selectedUser.nis }}</div>
            <!-- {{ form.nis }},{{ selectedUser }} -->
          </div>
          <hr />
          <div class="row justify-content-between">
            <b-input-group prepend="Tanggal Masuk" size="sm" class="col-md-6">
              <b-form-input size="sm" type="date" v-model="tanggal" />
            </b-input-group>

            <b-button size="sm" @click="saveobatmasuk" class="float-right mr-3"
              ><b-icon-save /> Save</b-button
            >
          </div>
          <!-- {{ obat }} -->
          <!-- <b-button size="sm" @click="saveobat"><b-icon-save /></b-button> -->
          <table class="col-md mt-0 mt-2">
            <tr>
              <th class="text-center">
                <!-- <b-button variant="outline-primary" style="font-size: 12px"> -->
                <b-icon-plus-square
                  size="sm"
                  style="cursor: pointer !important"
                  @click="obat.push({ kode: '', jumlah: 1 })"
                />
                <!-- </b-button> -->
              </th>
              <th>Nama Obat</th>
              <!-- <th>Nama Obat</th> -->
              <th class="text-right">JmlMasuk</th>
              <th class="text-right">Stok Saatini</th>
            </tr>
            <tbody v-for="(det, k) in obat" :key="k">
              <tr>
                <td>
                  <b-button
                    variant="outline-primary"
                    style="font-size: 12px"
                    size="sm"
                    ><b-icon-trash @click="obat.splice(k, 1)"
                  /></b-button>
                </td>
                <td>
                  <b-form-select
                    v-model="det.kode"
                    :options_="listobat"
                    :options="filteredOptions(k)"
                    size="sm"
                    @input="
                      det.stok =
                        listobat.find((item) => item.value === det.kode)
                          ?.stok || 0
                    "
                  />
                </td>
                <!-- <td>{{ det.namaobat }}</td> -->
                <td>
                  <b-form-input
                    class="text-right"
                    v-model="det.jumlah"
                    size="sm"
                    type="number"
                  />
                </td>

                <td>
                  <b-form-input
                    class="text-right"
                    v-model="det.stok"
                    size="sm"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-modal
      id="bv-modal-listobat"
      hide-footer
      no-close-on-backdrop
      scrollable
      size="md"
    >
      <template #modal-title>
        <b>List Data Obat</b>
        <b-icon-arrow-repeat
          @click="getobat"
          style="cursor: pointer"
          title="Refresh Data"
          class="ml-4"
        />
      </template>
      <b-table
        :items="dataobat"
        :fields="listfields"
        responsive
        hover
        small
        class="mt-2 border-bottom border-top"
        style="font-size: 13px"
        :sticky-headerx="700"
        :busy="isbusy"
      >
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
      </b-table>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Obatmasuk",
  props: ["listobat"],
  data() {
    return {
      query: "",
      users: [],
      dataobat: [],
      obat: [{ kode: "", jumlah: 1, stok: 0 }],
      selectedUser: {},
      isbusy: false,
      listfields: [
        { key: "kode", label: "Kode", sortable: true },
        { key: "namaobat", label: "Nama Obat", sortable: true },
        { key: "satuan", label: "Satuan", sortable: true },
        { key: "stok", label: "Stok", sortable: true },
      ],
      tanggal: "",
    };
  },
  mounted() {
    this.tanggal = this.$func.tglhariini();
  },
  methods: {
    getobat() {
      this.isbusy = true;
      axios
        .get(this.$appUrl + "dataobat.php?token=" + this.$globalData.Token)
        .then((res) => {
          this.dataobat = res.data;
          this.isbusy = false;
        });
    },
    filteredOptions(index) {
      const usedCodes = this.obat
        .filter((_, i) => i !== index) // selain row ini
        .map((o) => o.kode);

      return this.listobat.filter((opt) => !usedCodes.includes(opt.value));
    },
    saveobatmasuk() {
      const payload = {
        obat: this.obat,
      };
      // alert(JSON.stringify(payload));
      axios
        .post(
          this.$appUrl +
            "simpanobatmasuk.php?token=" +
            this.$globalData.Token +
            "&username=" +
            this.$globalData.UserId +
            "&tanggal=" +
            this.tanggal,
          payload
        )
        .then((res) => {
          console.log("data masuk obat", res.data);
          this.getobat();
          this.obat = [{ kode: "", jumlah: 1, stok: 0 }];
        });
    },
  },
};
</script>

<style>
.gradient {
  background: linear-gradient(to bottom, #134a6e 33%, #66ff99 100%);
}
</style>
